module.exports = __webpack_public_path__ + "static/media/menu-branding-icon.647446cf.svg";